var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_484_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7496 15.7501C33.3356 15.7501 32.9996 15.4141 32.9996 15.0001C32.9996 10.5931 31.2836 6.4486 28.1666 3.3331C27.8741 3.0406 27.8741 2.5651 28.1666 2.2726C28.4591 1.9801 28.9346 1.9801 29.2271 2.2726C32.6276 5.6716 34.4996 10.1911 34.4996 15.0001C34.4996 15.4141 34.1636 15.7501 33.7496 15.7501Z",
    fill: "#00A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 15.7501C1.836 15.7501 1.5 15.4141 1.5 15.0001C1.5 10.1911 3.372 5.6716 6.7725 2.2726C7.065 1.9801 7.5405 1.9801 7.833 2.2726C8.1255 2.5651 8.1255 3.0406 7.833 3.3331C4.716 6.4486 3 10.5931 3 15.0001C3 15.4141 2.664 15.7501 2.25 15.7501Z",
    fill: "#00A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 6.27C19.836 6.27 19.5 5.934 19.5 5.52V3C19.5 2.1735 18.8265 1.5 18 1.5C17.1735 1.5 16.5 2.1735 16.5 3V5.52C16.5 5.934 16.164 6.27 15.75 6.27C15.336 6.27 15 5.9355 15 5.52V3C15 1.3455 16.3455 0 18 0C19.6545 0 21 1.3455 21 3V5.52C21 5.9355 20.664 6.27 20.25 6.27Z",
    fill: "#00A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 36C15.105 36 12.75 33.645 12.75 30.75C12.75 30.336 13.086 30 13.5 30C13.914 30 14.25 30.336 14.25 30.75C14.25 32.817 15.933 34.5 18 34.5C20.067 34.5 21.75 32.817 21.75 30.75C21.75 30.336 22.086 30 22.5 30C22.914 30 23.25 30.336 23.25 30.75C23.25 33.645 20.895 36 18 36Z",
    fill: "#00A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.75 31.5H5.25C4.0095 31.5 3 30.4905 3 29.25C3 28.5915 3.2865 27.969 3.7875 27.54C6.1515 25.542 7.5 22.635 7.5 19.557V15C7.5 9.21 12.21 4.5 18 4.5C23.79 4.5 28.5 9.21 28.5 15V19.557C28.5 22.6365 29.8485 25.542 32.2005 27.5295C32.7135 27.969 33 28.5915 33 29.25C33 30.4905 31.992 31.5 30.75 31.5ZM18 6C13.0365 6 9 10.0365 9 15V19.557C9 23.079 7.458 26.4015 4.7685 28.6755C4.596 28.8225 4.5 29.031 4.5 29.25C4.5 29.664 4.836 30 5.25 30H30.75C31.164 30 31.5 29.664 31.5 29.25C31.5 29.031 31.404 28.8225 31.2375 28.68C28.5435 26.4015 27 23.0775 27 19.557V15C27 10.0365 22.9635 6 18 6Z",
    fill: "#00A2FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_484_760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.f80e7b79e871ef45acc7ac168ba1fb28.svg";
export { ForwardRef as ReactComponent };